import { getProjectAssetUrls } from "./getProjectAssetUrls";
import type { GetProjectAssetUrl } from "./types";

export const getProjectAssetUrl: GetProjectAssetUrl = async ({
  projectId,
  key,
}) => {
  const urls = await getProjectAssetUrls({ projectId, keys: [key] });
  return urls[key];
};
